import { FC } from 'react';
import styles from './Loader.module.scss';

interface Props {
  text?: string;
  size?: number;
  color?: 'dark' | 'light';
  extraClasses?: string;
}

const Loader: FC<Props> = ({ text, size = 7, color = 'dark', extraClasses = '' }) => {
  return (
    <div className={`${styles.loader} ${extraClasses}`} data-testid="loader">
      <div className={styles.container}>
        {text && <div className={styles.text}>{text}</div>}
        <div className={`${styles.spinnerDual} ${styles[color]} ${styles['size-' + size]}`} />
      </div>
    </div>
  );
};

export default Loader;
